import React, { useEffect, useState } from 'react';
import styles from './ImageNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import ImageModal from './image-modal/ImageModal';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const VideoNode = ({ id, selected }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isError, setIsError] = useState(node?.is_Error || false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [videoSrc, setVideoSrc] = useState(null);

  const media = node?.media;
  const isEmptyMedia = !media?.uploadedFile && !media?.url;
  const isImageURL = media?.isURL && media?.url;

  useEffect(() => {
    if (media?.uploadedFile) {
      const objectUrl = URL.createObjectURL(media.uploadedFile);
      setVideoSrc(objectUrl);

      return () => URL.revokeObjectURL(objectUrl); // Cleanup on unmount
    } else {
      setVideoSrc(media?.url || null);
    }
  }, [media?.uploadedFile, media?.url]);

  useEffect(() => {
    if (node?.media) {
      if (isEmptyMedia) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.media]);

  return (
    <>
      <NodeContainer
        name={node?.title ?? 'Video Block'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        node={node}
        isError={isError}
      >
        <Handle
          type="target"
          position={Position.Left}
          className="custom-handle"
        />
        <div>
          {isEmptyMedia ? (
            <div className={styles.document}>
              <SvgWithBranding type="node-video" color="#787878" />
              <div className={styles.text}>
                <p>Video</p>
                <span>Upload a video</span>
              </div>
            </div>
          ) : (
            <div
              className={`${styles.document} ${
                !isImageURL ? styles.image : null
              }`}
            >
              <div className={styles.text}>
                <video
                  autoPlay
                  loop
                  muted
                  id={styles['video']}
                  key={videoSrc} // Force re-render
                >
                  <source src={videoSrc} type="video/mp4" />
                </video>
              </div>
            </div>
          )}
        </div>

        <Handle
          type="source"
          position={Position.Right}
          className="custom-handle"
        />
      </NodeContainer>
      <ImageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Video"
        id={id}
        isError={isError}
        allowedExtensions={['mp4', 'mkv', 'avi', 'mov', 'wmv', 'flv', 'webm']}
      />
    </>
  );
};

export default VideoNode;
